import ProfilePage from "../shared/ProfilePage";
import EmployeeLayout from "../../layouts/EmployeeLayout";

export default function EmployeeProfile() {
  return (
    <ProfilePage
      Layout={EmployeeLayout}
      roleTitle="Employee"
      editable={false}
    />
  );
}